import * as util from "./util";

const Analytics = {
    util
};

export default Analytics;
